import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { integrationsApi } from 'src/services';

export type OnboardEhrPayload = {
  org_uuid: string;
  ehr_system: string;
  practice_id: string;
  user_email: string;
  timezone?: string;
};

export type OnboardEhrResponse = {
  success: boolean;
  code: number;
  message?: string;
  data?: unknown;
};

export const useOnboardEhr = (
  options?: UseMutationOptions<OnboardEhrResponse, Error, OnboardEhrPayload>
) => {
  const { mutateAsync, ...rest } = useMutation<
    OnboardEhrResponse,
    Error,
    OnboardEhrPayload
  >({
    mutationFn: (payload) =>
      integrationsApi
        .post<OnboardEhrResponse>('/ehr/onboarding', {
          timezone: 'UTC',
          ...payload,
        })
        .then((res) => res.data),
    ...options,
  });

  return { onboardEhr: mutateAsync, ...rest };
};
